<template>
	<input
		class
		@input="updateValue"
		:value="value"
		type="text"
		:placeholder="displayedPlaceholder"
	/>
</template>
<script>
/** @format */

export default {
	name: 'BaseInput',
	props: {
		label: {
			type: String
		},
		placeholder: {
			type: String
		},
		value: [String, Number]
	},
	computed: {
		displayedPlaceholder() {
			if (this.placeholder) return this.placeholder;
			if (this.label) return this.label;
			return '';
		}
	},
	methods: {
		updateValue(e) {
			this.$emit('input', e.target.value);
		}
	}
};
</script>
